import React from 'react';

const Inicial = () => {
  return (
    <div className="p-8 bg-white rounded-lg shadow-lg text-center">
      <h1 className="text-2xl font-bold mb-4 text-green-700">Página de Produção Online</h1>
      <p className="mt-2 text-gray-700">
        Este é o componente para a gestão de produção online.
        Você pode começar a adicionar tabelas, gráficos ou formulários aqui.
      </p>
    </div>
  );
};

export default Inicial;